import { CTAButton } from 'src/common/components/Button';
import { media } from 'src/common/styles/breakpoints';
import styled, { css } from 'styled-components';

export { LayoutContainer as AspspLayoutContainer } from 'src/common/components/Layout/LayoutContainer';

export const SmallHeading = styled.h4`
  font-size: 1rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.text.primary};
`;

export const SecondaryText = styled.p`
  color: ${({ theme }) => theme.text.secondary};
  font-size: 0.875rem;
  line-height: 1.5;
`;

export const ListWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0.5rem;
  margin-top: 1.5rem;
  border-radius: 0.5rem;
  overflow-y: auto;
  padding: 0.25rem;

  ::-webkit-scrollbar {
    border-left: 4px solid transparent;
    width: 0.25rem;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: #d7d7d7;
    border-radius: 0.125rem;
  }

  ::-webkit-scrollbar-thumb:hover {
    filter: brightness(0.2);
  }

  ${media.w.min.px576(css`
    margin-top: 2rem;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    justify-content: center;
    grid-gap: 0.5rem;
    padding-bottom: 2rem;
  `)}
`;

export const StyledCTAButton = styled(CTAButton)<{ $showOnMobile: boolean }>`
  ${({ $showOnMobile }) =>
    $showOnMobile
      ? css`
          position: fixed;
          z-index: 10;
          bottom: 2.5%;
          left: 5%;
          width: 90%;
          display: block;
        `
      : css`
          display: none;
        `}

  ${media.w.min.px576(css`
    position: static;
    z-index: 1;
    display: block;
    width: 22.5rem;
  `)}
`;

export const AgreementWrapper = styled.div`
  display: none;
  ${media.w.min.px576(css`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `)}
`;

export const TestWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    ${media.w.min.px576(css`
        display: none;
    `)}
`;